export default __webpack_public_path__ + "images/be8c0b22769c29d7afa9cdf58e74391c-kidney2.png";